import { DEFAULT_THEME, ThemeProvider } from '@zendeskgarden/react-theming'
import { Router } from './router'
import { Header } from '@components/molecules'
import { UserProvider } from '@context/UserContext'

function App() {

  return (
    <ThemeProvider theme={DEFAULT_THEME}>
      <UserProvider>
        <Header />
        <Router />
      </UserProvider>
    </ThemeProvider>
  )
}

export default App
